import {
  VERIFY_OTP,
  GENERATE_OTP_CODE,
  SET_PENDING,
  SET_GENERATING,
  GENERATE_CODE_SUCCESS,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_FAILED,
  VERIFY_CLEAR_ERROR,
  RESET_OTP,
  SET_OTP_MODE,
  SET_RO_EFR,
  MAX_ATTEMPTS_EXCEEDED,
  SET_VERIFIED_CREDENTIAL
} from "../actions/otp";
import { APPLICANT_INFO_FORM } from "../actions/applicantInfoForm";
import { handleActions, composeActions } from "../../utils/redux-utils";

export const initialState = {
  isGenerating: false,
  isGenerated: false,
  isPending: false,
  isVerified: false,
  verificationError: false,
  mode: "",
  otpTokenValidityInSec: "",
  otpTokenValidUntil: "",
  generatedAt: Date.now(),
  attempts: 0,
  isRoInviteEFR: false,
  maxAttemptsExceeded: false,
  maxAttemptsServerError: "",
  verifiedCredential: {}
};

export default handleActions(
  {
    [VERIFY_OTP]: state => ({
      ...state,
      verificationError: false,
      isVerified: false,
      isPending: true
    }),
    [composeActions(GENERATE_OTP_CODE, APPLICANT_INFO_FORM)]: (state, action) => ({
      ...state,
      verificationError: false,
      isVerified: false,
      isGenerating: true,
      isGenerated: false,
      mode: action.payload.mode || "",
      otpTokenValidityInSec: "",
      otpTokenValidUntil: "",
      isPending: false,
      error: ""
    }),
    [SET_PENDING]: (state, action) => ({
      ...state,
      isPending: action.payload
    }),
    [SET_GENERATING]: (state, action) => ({
      ...state,
      isGenerating: action.payload
    }),
    [GENERATE_CODE_SUCCESS]: state => ({
      ...state,
      isGenerating: false,
      isGenerated: true,
      isPending: false,
      generatedAt: Date.now(),
      attempts: 0,
      maxAttemptsExceeded: false
    }),
    [VERIFY_CODE_SUCCESS]: state => ({
      ...state,
      isGenerating: false,
      isGenerated: false,
      isVerified: true,
      verificationError: false,
      isPending: false,
      attempts: 0,
      maxAttemptsExceeded: false
    }),
    [RESET_OTP]: state => ({
      ...initialState,
      isRoInviteEFR: state.isRoInviteEFR
    }),
    [VERIFY_CODE_FAILED]: state => ({
      ...state,
      isVerified: false,
      verificationError: true,
      isPending: false,
      isGenerating: false, // Set generating to false on failure
      attempts: state.attempts + 1
    }),
    [VERIFY_CLEAR_ERROR]: state => ({
      ...state,
      verificationError: false
    }),
    [SET_OTP_MODE]: (state, action) => ({
      ...state,
      mode: action.payload
    }),
    [SET_RO_EFR]: (state, action) => ({
      ...state,
      isRoInviteEFR: action.payload
    }),
    [MAX_ATTEMPTS_EXCEEDED]: (state, action) => ({
      ...state,
      maxAttemptsExceeded: true,
      maxAttemptsServerError: action.payload
    }),
    [SET_VERIFIED_CREDENTIAL]: (state, action) => ({
      ...state,
      verifiedCredential: {
        ...state.verifiedCredential,
        ...(action.payload.email && { email: action.payload.email }),
        ...(action.payload.mobileNo && { mobileNo: action.payload.mobileNo }),
        ...(action.payload.sid && { sid: action.payload.sid })
      }
    })
  },
  initialState
);
